export default "__VITE_ASSET__BCtHT9ZL__"